<script lang="ts">
	import DefaultButton from '../../../basic/buttons/DefaultButton.svelte';
	import DefaultTextInput from '../../../basic/input/DefaultTextInput.svelte';
	import DefaultTextareaInput from '../../../basic/input/DefaultTextareaInput.svelte';
	import InputLabel from '../../../basic/input/InputLabel.svelte';
	import Modal from '../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../basic/modal/ModalHeader.svelte';
	import { editFolderStore } from '../../../stores/FolderStore.svelte';
	import type { Folder } from '../../../types/FolderTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		patchFolderStore: (folder: Folder) => Promise<void>;
	}

	let { patchFolderStore }: Props = $props();
</script>

{#if $editFolderStore != null}
	<Modal
		onModalClose={() => {
			$editFolderStore = null;
		}}
	>
		{#snippet header()}
			{#if $editFolderStore}
				<ModalHeader
					text={$_('folderview.lbl_folder_edit').replace('{}', $editFolderStore.shortName)}
				/>
			{/if}
		{/snippet}
		{#snippet content()}
			{#if $editFolderStore}
				<div class="grid gap-2">
					<InputLabel label={$_('folderview.lbl_folder_short')} />
					<DefaultTextInput
						propertyName="shortName"
						maxLength={25}
						bind:value={$editFolderStore.shortName}
					/>

					<InputLabel label={$_('folderview.lbl_folder_name')} />
					<DefaultTextInput
						propertyName="name"
						maxLength={255}
						focusOnStart={true}
						bind:value={$editFolderStore.name}
					/>

					<InputLabel label={$_('folderview.lbl_folder_memo')} />
					<DefaultTextareaInput
						maxLength={255}
						propertyName="memo"
						bind:value={$editFolderStore.memo}
					/>
				</div>
			{/if}
		{/snippet}
		{#snippet footer()}
			<div>
				<!-- Buttons -->
				<div class="flex justify-end gap-4">
					<DefaultButton
						secondary={true}
						onClick={() => {
							$editFolderStore = null;
						}}
						text={$_('general.lbl_cancel')}
					/>
					<DefaultButton
						onClick={() => {
							if ($editFolderStore) {
								patchFolderStore($editFolderStore);
							}
						}}
						text={$_('general.lbl_accept')}
					/>
				</div>
			</div>
		{/snippet}
	</Modal>
{/if}
